import {
  BaseHttpClient,
  IResponseModel as IResponseModelExported,
  IResponseModelWithPagination as IResponseModelWithPaginationExported,
  TDataWithPagination as TDataWithPaginationExported,
} from "@tedivo/tedivo-dom-helpers";

import { createErrorNotification } from "../notifications/createNotification";
import { getTranslation } from "../i18/i18tn";
import { onOffLineObserver } from "../offline/observer/OnOffLineObserver";
import securityModule from "../security/SecurityModule";

export default class HttpClient extends BaseHttpClient {
  constructor(
    baseUrl?: string,
    baseHeaders: Record<string, string> = {},
    timeout = 30000,
  ) {
    super(
      baseUrl || process.env.NX_PUBLIC_API_URL || "http://127.0.0.1:3000",
      {
        onOffLineObserver,
        setAuthorizationHeaders,
        notifyXhrRequestFired,
        notifyError,
      },
      baseHeaders,
      timeout,
    );
  }
}

/** Add the security module information for authorization */
function setAuthorizationHeaders() {
  return {
    Authorization: `Bearer ${securityModule.idToken}`,
    "X-Tvd-Org-Id": securityModule.currentOrganizationId,
  };
}

/** Notify the security module about a non anonymous request */
function notifyXhrRequestFired(isAnonymous: boolean) {
  if (!isAnonymous) securityModule.xhrRequestFired();
}

/** Handle errors and notifications */
function notifyError(
  httpCode: number,
  code: "response" | "request" | "unknown",
  message: string,
) {
  createErrorNotification(getTranslation(message), 5000);

  switch (code) {
    case "response":
      if (httpCode === 401) {
        securityModule.signOut();
      } else if (httpCode === 403) {
        securityModule.dispatchEvent(new CustomEvent("httpCallProhibited"));
      }
      break;
    case "request":
      securityModule.dispatchEvent(new CustomEvent("ajaxError"));
      break;
  }
}

export type IResponseModel<T> = IResponseModelExported<T>;

export type IResponseModelWithPagination<T> =
  IResponseModelWithPaginationExported<T>;

export type TDataWithPagination<T> = TDataWithPaginationExported<T>;
